import {openDb} from '../../../Services/BrowserDatabaseIDB';

export function getSpecificEventReceiptDetails(eventId, _receipt_id) {
    console.log('getSpecificEventReceiptDetails');
    return new Promise(function(resolve, reject) {
        openDb('pa', 1, function(upgradeDb) {

            console.log('making a new object store');
            if (!upgradeDb.objectStoreNames.contains('pa_data')) {
                upgradeDb.createObjectStore('pa_data');
                upgradeDb.createObjectStore('pa_photos');
            }

        }).then(function(db) {
            const tx = db.transaction('pa_data', 'readonly');
            const dataStore = tx.objectStore('pa_data');

            // get the Event from the Events array
            const getRequest = dataStore.get('Events');
            getRequest.then(function(result) {
                const event = result.find(evt => evt.id === eventId);
                console.log('event:', event);

                if (!event) {
                    return reject(`Event with ID ${eventId} not found`);
                }

                console.log('Found the Event; looking for receipt id:', _receipt_id);

                // Get the specific receipt
                const receipt = event.receipts.find(p => p.id === _receipt_id);
                console.log('receipt:', receipt);

                if (!receipt) {
                    return reject(`Photo with ID ${_receipt_id} not found in Event ${eventId}`);
                }

                resolve(receipt);
            }).catch(function(error) {
                console.error('Error retrieving receipt:', error);
                reject(error);
            });

        }).catch(function(error) {
            console.error('Error:', error);
            reject(error);
        });
    });
}

export function addEventAttendeeReceiptDetails(event_id, receipt_id, full_data, thumbnail_data){
    return new Promise(function (resolve, reject) {
        openDb('pa', 1, function (upgradeDb) {
            if (!upgradeDb.objectStoreNames.contains('pa_data')) {
                upgradeDb.createObjectStore('pa_data');
            }
            if (!upgradeDb.objectStoreNames.contains('pa_photos')) {
                upgradeDb.createObjectStore('pa_photos');
            }
        })
            .then(function (db) {
                const tx = db.transaction('pa_data', 'readwrite');
                const dataStore = tx.objectStore('pa_data');

                // Get the events array by key "Events"
                return dataStore.get('Events').then(eventsArray => {
                    if (!eventsArray) {
                        eventsArray = [];
                    }

                    // Find the event by ID
                    const eventIndex = eventsArray.findIndex(event => event.id === event_id);

                    if (eventIndex !== -1) {
                        // Get the specific event
                        const event = eventsArray[eventIndex];

                        // Find the receipt to update
                        const receiptIndex = event.receipts?.findIndex(r => r.id === receipt_id);

                        if (receiptIndex !== -1) {
                            const receipt = event.receipts[receiptIndex];

                            // ✅ Update receipt properties
                            receipt.thumbnail_data = thumbnail_data;
                            receipt.thumbnail_loaded = true;
                            receipt.full_data = full_data;
                            receipt.full_data_loaded = true;


                            // Replace updated receipt in the array
                            event.receipts[receiptIndex] = receipt;

                            // Save updated event
                            eventsArray[eventIndex] = event;

                            return dataStore.put(eventsArray, 'Events').then(() => {
                                console.log(`✅ Updated Receipt image data for Event ID ${event_id}`);
                                resolve(true);
                            });
                        } else {
                            console.error(`❌ Receipt with ID ${receipt_id} not found in event.`);
                            resolve(false);
                        }
                    } else {
                        console.error(`Event with ID ${event_id} not found.`);
                        return false;
                    }
                });
            })
            .catch(function (error) {
                console.error('Database error:', error);
                reject(error);
            });
    });
}
export function addEventReceiptImage(_event_id, _receipt) {
    console.log('addEventReceiptImage :');

    return new Promise(function (resolve, reject) {
        openDb('pa', 1, function (upgradeDb) {
            if (!upgradeDb.objectStoreNames.contains('pa_data')) {
                upgradeDb.createObjectStore('pa_data');
            }
            if (!upgradeDb.objectStoreNames.contains('pa_photos')) {
                upgradeDb.createObjectStore('pa_photos');
            }
        })
            .then(function (db) {
                const tx = db.transaction('pa_data', 'readwrite');
                const dataStore = tx.objectStore('pa_data');

                // Get the events array by key "Events"
                return dataStore.get('Events').then(eventsArray => {
                    if (!eventsArray) {
                        eventsArray = [];
                    }

                    // Find the event by ID
                    const eventIndex = eventsArray.findIndex(event => event.id === _event_id);

                    if (eventIndex !== -1) {
                        // Get the specific event
                        const event = eventsArray[eventIndex];

                        // Find the receipt to update
                        const receiptIndex = event.receipts?.findIndex(r => r.id === _receipt.id);

                        if (receiptIndex !== -1) {
                            const receipt = event.receipts[receiptIndex];

                            // ✅ Update receipt properties
                            receipt.thumbnail_data = _receipt.thumbnail_data;
                            receipt.thumbnail_loaded = true;

                            // (optional) also update full_data if passed in
                            if (_receipt.full_data) {
                                receipt.full_data = _receipt.full_data;
                                receipt.full_data_loaded = true;
                            }

                            // Replace updated receipt in the array
                            event.receipts[receiptIndex] = receipt;

                            // Save updated event
                            eventsArray[eventIndex] = event;

                            return dataStore.put(eventsArray, 'Events').then(() => {
                                console.log(`✅ Updated Receipt image data for Event ID ${_event_id}`);
                                resolve(true);
                            });
                        } else {
                            console.error(`❌ Receipt with ID ${_receipt.id} not found in event.`);
                            resolve(false);
                        }
                    } else {
                        console.error(`Event with ID ${_event_id} not found.`);
                        return false;
                    }
                });
            })
            .catch(function (error) {
                console.error('Database error:', error);
                reject(error);
            });
    });
}

export function addEventReceiptImageThumbnail(_event_id, _receipt_id, _thumbnail_data) {
    console.log('addEventReceiptImageThumbnail :'+_event_id+" : "+_receipt_id);

    return new Promise(function (resolve, reject) {
        openDb('pa', 1, function (upgradeDb) {
            if (!upgradeDb.objectStoreNames.contains('pa_data')) {
                upgradeDb.createObjectStore('pa_data');
            }
            if (!upgradeDb.objectStoreNames.contains('pa_photos')) {
                upgradeDb.createObjectStore('pa_photos');
            }
        })
            .then(function (db) {
                const tx = db.transaction('pa_data', 'readwrite');
                const dataStore = tx.objectStore('pa_data');

                // Get the events array by key "Events"
                return dataStore.get('Events').then(eventsArray => {
                    if (!eventsArray) {
                        eventsArray = [];
                    }

                    // Find the event by ID
                    const eventIndex = eventsArray.findIndex(event => event.id === _event_id);

                    if (eventIndex !== -1) {
                        // Get the specific event
                        const event = eventsArray[eventIndex];

                        // Find the receipt to update
                        const receiptIndex = event.receipts?.findIndex(r => r.id === _receipt_id);

                        if (receiptIndex !== -1) {
                            const receipt = event.receipts[receiptIndex];

                            // ✅ Update receipt properties
                            receipt.thumbnail_data = _thumbnail_data;
                            receipt.thumbnail_loaded = true;

                            // Replace updated receipt in the array
                            event.receipts[receiptIndex] = receipt;

                            // Save updated event
                            eventsArray[eventIndex] = event;

                            return dataStore.put(eventsArray, 'Events').then(() => {
                                console.log(`✅ Updated Receipt image data for Event ID ${_event_id}`);
                                resolve(true);
                            });
                        } else {
                            console.error(`❌ Receipt with ID ${_receipt_id} not found in event.`);
                            resolve(false);
                        }
                    } else {
                        console.error(`Event with ID ${_event_id} not found.`);
                        return false;
                    }
                });
            })
            .catch(function (error) {
                console.error('Database error:', error);
                reject(error);
            });
    });
}
